import type { FilterOption } from '@lighthouse/core'
import { atomWithImmer } from 'jotai-immer'

// id 为 blockId-filterItemId
export const filterBlockOptionsAtom = atomWithImmer<Record<string, FilterOption[]>>({})
